import React, { useEffect, useState } from "react";

import "../../styles/InputTag.css";
import { WithContext as ReactTags } from "react-tag-input";
import FieldErrorMsg from "./FieldErrorMsg";
import notify from "./notify";

// Key codes for tag input handling
const KeyCodes = {
  space: 32,
  comma: 188,
  enter: 13,
};

const delimiters = [KeyCodes.enter, KeyCodes.comma];

const InputTag = ({
  title,
  suggestions = [],
  value = [],
  placeholder,
  formik,
  id,
  setState,
  inputWrapperClass = "min-h-[5rem] max-h-32 py-2.5",
  containerClass = "w-full",
  required,
  maxLimit = 50,
}) => {
  const [currentValue, setCurrentValue] = useState("");

  // Handle tag deletion
  const handleDelete = (i) => {
    if (formik) {
      let cloneValue = [...value];
      formik.setFieldValue(
        id,
        cloneValue?.filter((tag, index) => index !== i)
      );
    } else setState(value.filter((tag, index) => index !== i));
  };

  // Handle tag addition
  const handleAddition = (tag) => {
    let updatedTag = typeof tag === "string" ? { id: tag, text: tag } : tag;

    // Strip out any extra properties (like className) to avoid validation errors
    const cleanTag = {
      id: updatedTag.id || updatedTag.text,
      text: updatedTag.text
    };

    // Add the tag if within limits and has text
    if (value.length < 5 && cleanTag?.text?.length) {
      if (formik) formik.setFieldValue(id, [...value, cleanTag]);
      else setState([...value, cleanTag]);
    }

    setCurrentValue("");
  };

  // Handle tag dragging
  const handleDrag = (tag, currPos, newPos) => {
    const newTags = [...value.slice()];
    newTags.splice(currPos, 1);
    newTags.splice(newPos, 0, tag);
    if (formik) formik.setFieldValue(id, newTags);
    else setState(newTags);
  };

  // Check if there is an error
  const error = () => {
    if (formik && formik.touched?.[id] && formik.errors?.[id]) return true;
    else return false;
  };

  return (
    <div id={id} className={` ${containerClass} flex flex-col relative z-40`}>
      <div className="w-full flex justify-between mb-1.5 items-center h-7">
        <span>
          <span className="text-sm font-bold pl-2 "> {title} </span>
          {required && <span className="text-red-500 mr-2">*</span>}
        </span>
        {currentValue && (
          <button
            type="button"
            className="px-3 h-full text-sm text-white bg-primary rounded-lg md:hidden disabled:opacity-70"
          >
            Add Tag
          </button>
        )}
      </div>
      <div className="relative">
        <div
          className={`w-full border border-custom-gray-600 !rounded-[10px]  overflow-y-auto flex items-start px-3 input-tag-wrapper ${
            error() ? "border-red-500" : "focus-within:border-primary"
          } focus-within:border-2 custom-primary-tiny-scroll ${inputWrapperClass} `}
        >
          <ReactTags
            tags={value}
            suggestions={suggestions}
            delimiters={delimiters}
            handleDelete={handleDelete}
            handleAddition={handleAddition}
            handleInputChange={(val) => {
              setCurrentValue(val);
            }}
            handleDrag={handleDrag}
            inputFieldPosition="inline"
            autocomplete
            placeholder={placeholder}
            allowDeleteFromEmptyInput={false}
            autofocus={false}
            handleInputBlur={handleAddition}
            maxLength={maxLimit}
          />
        </div>
      </div>
      <FieldErrorMsg formik={formik} id={id} />
    </div>
  );
};

export default InputTag;
